export class Controls {
  isUp = false;
  isDown = false;
  isLeft = false;
  isRight = false;
  isAccept = false;
  isEscape = false;
  isRestart = false;
  vertical: number = 0;
  horizontal: number = 0;

  keyboardConfigWASD = {
    up: "KeyW",
    right: "KeyD",
    down: "KeyS",
    left: "KeyA",
    accept: "Enter",
    exit: "Escape",
    restart: "KeyR",
  };

  keyboardConfigZQSD = {
    up: "KeyZ",
    right: "KeyD",
    down: "KeyS",
    left: "KeyQ",
    accept: "Enter",
    exit: "Escape",
    restart: "KeyR",
  };

  keyboardConfigArrows = {
    up: "ArrowUp",
    right: "ArrowRight",
    down: "ArrowDown",
    left: "ArrowLeft",
    accept: "Enter",
    exit: "Escape",
    restart: "KeyR",
  };

  config = this.keyboardConfigArrows;

  constructor() {
    // keyboard
    document.addEventListener("keydown", (event) =>
      this.toggleKey(event, true)
    );
    document.addEventListener("keyup", (event) => this.toggleKey(event, false));

    // touch
    document.addEventListener("touchstart", (event) =>
      this.handleTouch(event, "start")
    );
    document.addEventListener("touchmove", (event) =>
      this.handleTouch(event, "move")
    );
    document.addEventListener("touchend", (event) =>
      this.handleTouch(event, "end")
    );
  }

  private toggleKey(event: KeyboardEvent, isPressed: boolean) {
    switch (event.code) {
      case this.config.up:
        this.isUp = isPressed;
        break;
      case this.config.down:
        this.isDown = isPressed;
        break;
      case this.config.left:
        this.isLeft = isPressed;
        break;
      case this.config.right:
        this.isRight = isPressed;
        break;
      case this.config.accept:
        this.isAccept = isPressed;
        break;
      case this.config.exit:
        this.isEscape = isPressed;
        break;
      case this.config.restart:
        this.isRestart = isPressed;
        break;
    }
  }

  startTouchPos: Touch | null = null;

  handleTouch(ev: TouchEvent, touchType: "start" | "move" | "end") {
    if (ev.touches.length >= 1 && ev.touches[0]) {
      if (touchType === "start" || touchType === "move") {
        if (touchType === "start") this.startTouchPos = ev.touches[0];
        if (this.startTouchPos != null) {
          this.isDown =
            this.startTouchPos.clientY - ev.touches[0].clientY < -50;
          this.isUp = this.startTouchPos.clientY - ev.touches[0].clientY > 50;
          this.isRight =
            this.startTouchPos.clientX - ev.touches[0].clientX < -50;
          this.isLeft = this.startTouchPos.clientX - ev.touches[0].clientX > 50;
          this.vertical = Math.min(
            1,
            Math.max(
              -1,
              (this.startTouchPos.clientY - ev.touches[0].clientY) / 100
            )
          );
          this.horizontal = Math.min(
            1,
            Math.max(
              -1,
              (this.startTouchPos.clientX - ev.touches[0].clientX) / 100
            )
          );
        }
        // console.log(this.vertical, this.horizontal);
        return;
      }
    }
    this.startTouchPos = null;
    this.isDown = false;
    this.isUp = false;
    this.isRight = false;
    this.isLeft = false;
    this.vertical = 0;
    this.horizontal = 0;
  }
}
